// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckboxFilterTag_root__y6Wu4","close":"CheckboxFilterTag_close___OhLo","closeIcon":"CheckboxFilterTag_closeIcon__fKoME"};